import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  School,
  Graduation,
  PostGraduation,
  SkillDropdowns,
} from "components/formGroups";

const Fresher = ({
  handleChange,
  graduationStreams,
  postGraduationStreams,
  skills,
  ...rest
}) => (
  <Fragment>
    <School handleChange={handleChange} {...rest} />
    <Graduation
      handleChange={handleChange}
      graduationStreams={graduationStreams}
      {...rest}
    />
    <PostGraduation
      handleChange={handleChange}
      postGraduationStreams={postGraduationStreams}
      {...rest}
    />
    <SkillDropdowns
      handleChange={handleChange}
      skills={skills}
      {...rest}
      required={false}
    />
  </Fragment>
);

Fresher.propTypes = {
  handleChange: PropTypes.func.isRequired,
  graduationStreams: PropTypes.array.isRequired,
  postGraduationStreams: PropTypes.array.isRequired,
};

export { Fresher };
